/** PDF и Word для прикрепления к медкнижке (лаборатория, исследования). */

export const CLIENT_ATTACHMENT_ACCEPT =
  '.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const ALLOWED_EXT = ['.pdf', '.doc', '.docx'];

const WORD_MIMES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export function isPdfAttachment(doc) {
  const mime = String(doc?.mimeType || '').toLowerCase();
  const name = String(doc?.originalName || doc?.title || '').toLowerCase();
  return mime.includes('pdf') || name.endsWith('.pdf');
}

export function isWordAttachment(doc) {
  const mime = String(doc?.mimeType || '').toLowerCase();
  const name = String(doc?.originalName || doc?.title || '').toLowerCase();
  return (
    WORD_MIMES.some((m) => mime.includes(m) || mime === m) ||
    name.endsWith('.doc') ||
    name.endsWith('.docx')
  );
}

export function isDocxAttachment(doc) {
  const mime = String(doc?.mimeType || '').toLowerCase();
  const name = String(doc?.originalName || doc?.title || '').toLowerCase();
  return (
    mime.includes('wordprocessingml') ||
    mime.includes('officedocument.wordprocessingml') ||
    name.endsWith('.docx')
  );
}

export function isLegacyDocAttachment(doc) {
  if (!isWordAttachment(doc)) return false;
  return !isDocxAttachment(doc);
}

export function isAllowedClientAttachment(file) {
  if (!file) return false;
  const name = String(file.name || '').toLowerCase();
  const type = String(file.type || '').toLowerCase();
  if (ALLOWED_EXT.some((ext) => name.endsWith(ext))) return true;
  if (type.includes('pdf')) return true;
  if (WORD_MIMES.some((m) => type === m || type.includes('word'))) return true;
  return false;
}

export function attachmentTypeLabel(doc) {
  if (isPdfAttachment(doc)) return 'PDF';
  if (isWordAttachment(doc)) return 'Word';
  return 'Файл';
}
